/* eslint-disable no-extra-boolean-cast */
import React, { useEffect, useState } from "react";
import { get, join } from "lodash";
import { shallowEqual, useSelector } from "react-redux";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { toAbsoluteUrl } from "../../globals/utils/toAbsoluteUrl";
import {
  POONAWALLA_USER_ROLES_TYPES,
  NAV_DROPDOWN_ROLES_MAPPER,
  ROUTES_ROLES_MAPPER,
  ROUTE_ROOT,
  ROUTE_SIGNIN,
  ROUTE_SIGNUP,
} from "../../globals/constants";
import { LAYOUT_CONFIG } from "../config";
import { verifyToken } from "../../globals/utils/jwtUtils";

import "./Header.scss";

const PoonaWallaHeaderRoutes = ({ userType }) => {
  return (
    <>
      {ROUTES_ROLES_MAPPER[POONAWALLA_USER_ROLES_TYPES.aliases[userType]].map(
        (routeConfig) => (
          <Tab
            key={routeConfig.title}
            disableRipple
            label={
              <Link
                key={routeConfig.title}
                to={routeConfig.to}
                className={`${
                  routeConfig.activeFor.some((activeFor) =>
                    Boolean(useRouteMatch({ path: activeFor, strict: true }))
                  ) && "active"
                }`}
                data-title={routeConfig.title}
              >
                {routeConfig.title}
              </Link>
            }
          />
        )
      )}
    </>
  );
};

const PoonaWallaNavActions = ({ activityData, userData }) => {
  return (
    <>
      {get(userData, "idToken") && verifyToken(get(userData, "idToken")) ? (
        <>
          {/* LOGGED IN USER DROPDOWN UI STARTS */}
          <button className="Header__UserContainer text-primary btn bg-transparent shadow-none">
            <span className="mr-3">
              {join([userData.first_name, userData.last_name], " ")}
            </span>
            <span>
              <i className="fa fa-chevron-down Header__UserContainer-down"></i>
              <i className="fa fa-chevron-up Header__UserContainer-up d-none"></i>
            </span>
            <div className="Header__UserContainer-dropdown">
              {NAV_DROPDOWN_ROLES_MAPPER[
                POONAWALLA_USER_ROLES_TYPES.aliases[get(userData, "user_type")]
              ].map((dropDownItem) => (
                <Link to={dropDownItem.to} key={dropDownItem.title}>
                  {dropDownItem.title}
                </Link>
              ))}
            </div>
          </button>
          {/* LOGGED IN USER DROPDOWN UI ENDS */}
        </>
      ) : (
        <>
          {/* NON LOGGED IN USER UI STARTS */}
          <Link
            to={ROUTE_SIGNUP}
            className={`MainButton MainButton__primary ${
              LAYOUT_CONFIG.SIGN_UP_BUTTON.hidden_on_routes.some((activeFor) =>
                Boolean(useRouteMatch({ path: activeFor, strict: true }))
              ) && "d-none"
            }`}
          >
            Sign Up
          </Link>
          <Link
            to={ROUTE_SIGNIN}
            className={`MainButton MainButton__primary outlined ml-3 ${
              LAYOUT_CONFIG.SIGN_IN_BUTTON.hidden_on_routes.some((activeFor) =>
                Boolean(useRouteMatch({ path: activeFor, strict: true }))
              ) && "d-none"
            }`}
          >
            Sign In
          </Link>
          {/* NON LOGGED IN USER UI ENDS */}
        </>
      )}
    </>
  );
};

const MobileNavItems = ({ userData }) => {
  return (
    <div className="d-flex flex-column">
      {!get(userData, "idToken") ? (
        <>
          <Link
            to={ROUTE_SIGNUP}
            className={`${
              LAYOUT_CONFIG.SIGN_UP_BUTTON.hidden_on_routes.some((activeFor) =>
                Boolean(useRouteMatch({ path: activeFor, strict: true }))
              ) && "d-none"
            }`}
          >
            Sign up
          </Link>
          <Link
            to={ROUTE_SIGNIN}
            className={`${
              LAYOUT_CONFIG.SIGN_IN_BUTTON.hidden_on_routes.some((activeFor) =>
                Boolean(useRouteMatch({ path: activeFor, strict: true }))
              ) && "d-none"
            }`}
          >
            Sign in
          </Link>
        </>
      ) : (
        <>
          {ROUTES_ROLES_MAPPER[
            POONAWALLA_USER_ROLES_TYPES.aliases[get(userData, "user_type")]
          ].map((routeConfig) => (
            <Link
              key={routeConfig.title}
              to={routeConfig.to}
              className={`${
                routeConfig.activeFor.some((activeFor) =>
                  Boolean(useRouteMatch({ path: activeFor, strict: true }))
                ) && "active"
              } text-decoration-none`}
              data-title={routeConfig.title}
            >
              {routeConfig.title}
            </Link>
          ))}

          {NAV_DROPDOWN_ROLES_MAPPER[
            POONAWALLA_USER_ROLES_TYPES.aliases[get(userData, "user_type")]
          ].map((dropDownItem) => (
            <Link
              to={dropDownItem.to}
              className={
                Boolean(
                  useRouteMatch({ path: dropDownItem.to, strict: true })
                ) && "active"
              }
              key={dropDownItem.title}
            >
              {dropDownItem.title}
            </Link>
          ))}
        </>
      )}
    </div>
  );
};

const Header = () => {
  const { authData } = useSelector(
    (store) => ({
      authData: store.auth.data || {},
    }),
    shallowEqual
  );

  const location = useLocation();

  const [isMobileNavOpen, setisMobileNavOpen] = useState(true);

  const toggleMobileNav = () => setisMobileNavOpen(!isMobileNavOpen);
  const handleCloseMobileNav = () => setisMobileNavOpen(false);

  useEffect(() => {
    handleCloseMobileNav();
  }, [location.pathname]);

  return (
    <div
      className={`Header d-flex flex-row justify-content-between align-items-center`}
    >
      <Link to={ROUTE_ROOT} className="Header__LogoContainer mr-md-5">
        <img
          className="Header__LogoContainer-logo"
          src={toAbsoluteUrl("/assets/logos/fedfina_logo_img.png")}
        />
      </Link>

      {get(authData, "idToken") && verifyToken(get(authData, "idToken")) && (
        <>
          {/* LOGGED IN USER NAV UI STARTS */}
          <Tabs
            className="Header__RoutesContainer justify-content-between align-items-center d-none d-lg-flex h-100"
            variant="scrollable"
            scrollButtons="auto"
          >
            <PoonaWallaHeaderRoutes userType={get(authData, "user_type")} />
          </Tabs>
          {/* LOGGED IN USER NAV UI ENDS */}
        </>
      )}

      <div className="Header__NavContainer d-none d-lg-block ml-md-5">
        <PoonaWallaNavActions userData={authData} />
      </div>

      {/* MOBILE NAVIGATION STARTS */}
      <div className="Header__MobileNavContainer d-block d-lg-none">
        <button
          onClick={toggleMobileNav}
          className={`btn shadow-none hamburgermenu ${
            isMobileNavOpen && "open"
          }`}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div
          className={`Header__MobileNavContainer-nav ${
            isMobileNavOpen && "open"
          }`}
          onClick={handleCloseMobileNav}
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            className="wrapper ml-auto p-5"
          >
            <MobileNavItems userData={authData} />
          </div>
        </div>
      </div>
      {/* MOBILE NAVIGATION ENDS */}
    </div>
  );
};

export default Header;
